import React from "react";
import { Checkbox, ListItemButton, ListItemIcon, ListItemText, styled } from "@mui/material";

import { ParentType } from "../../types";

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: theme.spacing(8),
}));

export interface CheckboxFilterItemChildProps {
  option: ParentType;
  value?: ParentType[];
  disabled?: boolean;
  onChange: (checked: boolean, item: ParentType) => void;
}

const CheckboxFilterItemChild: React.FC<CheckboxFilterItemChildProps> = ({ option, value = [], disabled, onChange }) => {
  return (
    <StyledListItemButton key={`${option.id}`} dense disabled={disabled} onClick={() => onChange(!value.includes(option), option)}>
      <ListItemIcon>
        <Checkbox
          name={`${option.id}`}
          color={disabled ? "default" : "primary"}
          checked={value.includes(option)}
          tabIndex={-1}
          onChange={(_, checked) => onChange(checked, option)}
        />
      </ListItemIcon>
      <ListItemText primary={option.title} />
    </StyledListItemButton>
  );
};

export default CheckboxFilterItemChild;
